import { VWOFlag } from '@/types/vwo';

import { getVWOValue } from './getVWOValue';
import getInstance from './instance';

export const isVWOFeatureEnabled = async (key: VWOFlag) => {
  const vwoClient = await getInstance();
  return getVWOValue({ key, vwoClient });
};
